<script setup>
import { isLangEnglish } from '../../utils/language_selector';
import { selectedLang } from '../../utils/selected_lang';

</script>

<template>
    <main>
        <div class="box">
            <div class="section1">
                <p class="title" data-aos="fade-up" data-aos-delay="100"><strong>
                        <span v-if="selectedLang() == 'en'">Contact Us</span>
                        <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">اتصل بنا</bdo></span>
                        <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">پەیوەندیمان پێوە بکەن</bdo></span>
                    </strong></p>
                <h3 class="title" data-aos="fade-up" data-aos-delay="200">
                    <span v-if="selectedLang() == 'en'">get in touch</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">تواصل معنا</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">پەیوەندی بکەن</bdo></span>

                </h3>
                <div class="info" data-aos="fade-up" data-aos-delay="300">
                    <span v-if="selectedLang() == 'en'">
                        <strong>HQ - Iraq</strong>
                        <p style="margin-top: 5px;">Erbil: Star Towers, Block B, No 6, 5th floor, 40 m street. <br>Baghdad: Farah & Al-Adyan building, No: 18 ,2nd floor, Hay Al-Jamiaa.</p>
                    </span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">
                            <strong>المقر الرئيسي العراق</strong>
                            <p>اربيل: ابراج النجوم، قطعة ب، رقم 6، الطابق الخامس، شارع 40م.</p>
                            <p>بغداد: عمارة فرح والعديان رقم: 18 الطابق الثاني حي الجامعة.</p>
                        </bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">
                            <strong>بارەگای سەرەکی عێراق</strong>
                            <p>هەولێر: ستار تاوەرز، بلۆکی بی، ژمارە ٦، نهۆمی پێنجەم، شەقامی ٤٠م.</p>
                            <p>بەغدا: بینای فەرەح و ئەلعەدیان، ژمارە: ١٨ ، نهۆمی دووەم، حەی ئەلجەمیعە.</p>
                        </bdo></span>


                </div>
            </div>
            <div class="section2" data-aos="fade-up" data-aos-delay="400">
                <div :class="{ 'line': isLangEnglish(), 'line-k': !isLangEnglish(), }" data-aos="fade-down" data-aos-delay="500"></div>
                <span v-if="selectedLang() == 'en'" >
                    <p><strong>Email </strong>Info@kurdos.co</p>
                    <p><strong>Phone </strong>+964 750 444 9416 , +964 772 969 0636</p>
                </span>
                <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">
                        <div dir="rtl">
                            <p><strong>البريد الإلكتروني:</strong> Info@kurdos.co</p>
                            <p><strong>الهاتف:</strong> +964 750 444 9416 ، +964 772 969 0636</p>
                        </div>

                    </bdo></span>
                <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">
                        <div dir="rtl">
                            <p><strong>ئیمەیڵ:</strong> Info@kurdos.co</p>
                            <p><strong>تەلەفۆن:</strong> +964 750 444 9416 ، +964 772 969 0636</p>
                        </div>

                    </bdo></span>


            </div>
        </div>
    </main>
</template>
<style scoped>

main {
    background: #F6F8FB;
    display: flex;
    align-items: start;
    justify-content: center;
    padding: 10px !important;
}
.dark main {
    background: #131313;
}
.box {
    width: 80%;
    background: white;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    border-radius: 20px;
    padding: 10px 0;
    display: flex;
    margin-top: 100px;
    margin-bottom: 50px;
}
.dark .box{
    background: #323232;
    color: white !important;
}


.section1,
.section2 {
    width: 50%;
    padding: 20px;

}

.section2 {
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    color: #073762;
    position: relative;
}
.dark .section2{
    color: #fff !important;
}

.section2 .line {
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
    background: lightgray;
    width: 2px;
    height: 45%;
}

.line-k {
    position: absolute;
    right: 0px;
    top: 50%;
    transform: translateY(-50%);
    background: lightgray;
    width: 2px;
    height: 45%;
}

.section2 p {
    margin: 0;
    padding: 5px;
}

.section1 .title{
    text-transform: uppercase;
}


.section1 p {
    color: #E43D36;
}

.section1 h3 {
    color: #073762;
}
.dark .section1 h3{
    color: #fff !important;
}



.info {
    margin-top: 20px;

}

.info strong {
    color: #073762;
    margin-bottom: 10px !important;
}
.dark .info strong, .dark .info p{
    color: #fff !important;
}

.info p {
    color: #073762 !important;
    font-size: small;
    text-transform: capitalize;
}

@media(max-width:768px) {

    .box {
        flex-direction: column;
        margin-top: 50px;
    }

    .section1,
    .section2 {
        width: 100%;
        padding: 20px;
    }

    .section2::before {
        display: none;
    }

    .box {
        width: 95%;
    }

    .line,
    .line-k {
        display: none;
    }
}
</style>